<template>
  <v-card>
    <v-card-title class="primary white--text">
      {{ $t("dashboard.addMultimedia") }}</v-card-title
    >

    <v-file-input
      :disabled="!$store.getters['auth/reliabilityWrite']"
      class="my-10 mx-8"
      prepend-icon="mdi-folder-multiple-image"
      accept="audio/*, video/*, image/*"
      ref="file"
      @change="uploadFiles"
      :loading="loading"
      :label="$t('dashboard.fileInput')"
      outlined
      dense
    ></v-file-input>
  </v-card>
</template>

<script>
import { storage } from "@/plugins/db";
export default {
  props: ["uid"],
  data: () => ({
    i: 0,
    progressUpload: 0,
    uploadTask: "",
    uploading: false,
    uploadEnd: false,
    loading: false,
    downloadURL: "",
    success: false
  }),
  methods: {
    async uploadFiles(file) {
      let folder = file.type.split("/");
      this.loading = true;
      await storage
        .ref(
          `equipments/${this.uid}/${folder[0]}/${this.withoutSpaces(file.name)}`
        )
        .put(file)
        .then(snapshot => {
          snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$emit("done", downloadURL);
          });
        });
      this.loading = false;
    },
    withoutSpaces(str) {
      const nameArray = str.split(" ");
      return nameArray.join("");
    }
  }
};
</script>
